import { render } from "./Account.vue?vue&type=template&id=f6859308&scoped=true&ts=true"
import script from "./Account.vue?vue&type=script&lang=ts"
export * from "./Account.vue?vue&type=script&lang=ts"

import "./Account.vue?vue&type=style&index=0&id=f6859308&scoped=true&lang=scss"

import exportComponent from "/Users/sylvainleris/Documents/workspace/ADETEC/AdConnect/fr.adetec.adconnect.www/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f6859308"]])

export default __exports__